import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";
import axios from "axios";
import { API_ESA_OFFICE } from "utils";
import { saveAs } from "file-saver";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Icon from "@mui/material/Icon";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import InputAdornment from "@mui/material/InputAdornment";
import CircularProgress from "@mui/material/CircularProgress";
import Chip from "@mui/material/Chip";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

// Material Dashboard 2 PRO React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import { API_ESA_OFFICE_UPLOAD } from "utils";
import { logoutUser } from "actions/AuthAction";

function DaftarUsers() {
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [dinasId, setDinasId] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
  const [userStatus, setUserStatus] = useState("");
  const [loadingDialog, setLoadingDialog] = useState(false);
  const [showDinasList, setShowDinasList] = useState(false);
  const [dinasList, setDinasList] = useState([]);
  const [selectedDinas, setSelectedDinas] = useState(null);
  const [openDinasModal, setOpenDinasModal] = useState(false);
  const [dinasModalSearch, setDinasModalSearch] = useState("");
  const [filteredDinasList, setFilteredDinasList] = useState([]);
  const [dinasStruktur, setDinasStruktur] = useState(null);
  const [loadingDinas, setLoadingDinas] = useState(true);
  const [loadingStruktur, setLoadingStruktur] = useState(true);
  const [jabatanOptions, setJabatanOptions] = useState([]);
  const [bidangOptions, setBidangOptions] = useState([]);
  const [listDinas, setListDinas] = useState([]);
  const [formData, setFormData] = useState({
    nama: "",
    email: "",
    nama_jabatan: "",
    pangkat: "",
    facebook: "",
    instagram: "",
    profil: null,
    instansi: "",
    jabatan: "",
    bidang: "",
    status: "",
    unit: "",
    bio: "",
    noHP: "",
    status_EO: "Aktif",
    // Field internal untuk keperluan backend (tidak ditampilkan)
    dinas_id: "",
    bidang_id: "",
    level_jabatan: "",
  });
  const navigate = useNavigate();
  // Mobile detection & infinite scroll state
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [visibleCount, setVisibleCount] = useState(25);
  const [isLoadingMore, setIsLoadingMore] = useState(false);

  // Observer for infinite scroll
  useEffect(() => {
    if (!isMobile) return; // hanya aktif di mobile
    const handleScroll = () => {
      const nearBottom =
        window.innerHeight + window.scrollY >= document.body.offsetHeight - 200;
      if (nearBottom && !isLoadingMore) {
        setIsLoadingMore(true);
        setTimeout(() => {
          setVisibleCount((prev) => prev + 25);
          setIsLoadingMore(false);
        }, 200);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isMobile, isLoadingMore]);

  const fetchListDinas = async () => {
    setLoadingDinas(true);
    try {
      const res = await axios.get(`${API_ESA_OFFICE}dinas`);
      const dinasData = res.data || [];

      setListDinas(dinasData);
    } catch (err) {
      console.error("Error fetching list dinas:", err);
      setListDinas([]);
    }
    setLoadingDinas(false);
  };

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      // simpan status user
      setUserStatus(user.status);
      // Cek apakah user adalah admin/super admin
      if (user.status !== "admin" && user.status !== "super admin") {
        swal({
          title: "Akses Ditolak!",
          text: "Hanya admin yang dapat mengakses halaman ini",
          icon: "error",
          button: "OK",
        }).then(() => {
          navigate("/dashboard");
        });
        return;
      }
      setDinasId(user.dinas_id);
      fetchListDinas();
      fetchUsers();
    } else {
      logoutUser(navigate);
    }
  }, []);

  useEffect(() => {
    // Filter users berdasarkan search term
    if (searchTerm) {
      const filtered = users.filter(
        (user) =>
          user.nama.toLowerCase().includes(searchTerm.toLowerCase()) ||
          user.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
          (user.nama_dinas &&
            user.nama_dinas.toLowerCase().includes(searchTerm.toLowerCase()))
      );
      setFilteredUsers(filtered);
    } else {
      setFilteredUsers(users);
    }
  }, [searchTerm, users]);

  const getPangkatLabel = (value) => {
    const pangkatMap = {
      IA: "Juru Muda (I/a)",
      IB: "Juru Muda Tingkat I (I/b)",
      IC: "Juru (I/c)",
      ID: "Juru Tingkat I (I/d)",
      IIA: "Pengatur Muda (II/a)",
      IIB: "Pengatur Muda Tingkat I (II/b)",
      IIC: "Pengatur (II/c)",
      IID: "Pengatur Tingkat I (II/d)",
      IIIA: "Penata Muda (III/a)",
      IIIB: "Penata Muda Tingkat I (III/b)",
      IIIC: "Penata (III/c)",
      IIID: "Penata Tingkat I (III/d)",
      IVA: "Pembina (IV/a)",
      IVB: "Pembina Tingkat I (IV/b)",
      IVC: "Pembina Utama Muda (IV/c)",
      IVD: "Pembina Utama Madya (IV/d)",
    };
    return pangkatMap[value] || value;
  };

  useEffect(() => {
    if (selectedDinas && selectedDinas.dinas_id) {
      fetchStruktur(selectedDinas.dinas_id);
      setFormData((prevData) => ({
        ...prevData,
        instansi: selectedDinas.nama_dinas,
        dinas_id: selectedDinas.dinas_id,
        // Reset jabatan dan bidang ketika dinas berubah
        jabatan: "",
        bidang: "",
        bidang_id: "",
        level_jabatan: "",
      }));
    }
  }, [selectedDinas]);

  // Hitung daftar dinas unik beserta jumlah user dan breakdown status
  useEffect(() => {
    if (!users || users.length === 0) {
      setDinasList([]);
      return;
    }
    const map = new Map();
    users.forEach((u) => {
      const key = u.dinas_id || 0;
      const name = u.nama_dinas || "-";
      const prev = map.get(key) || {
        dinas_id: key,
        nama_dinas: name,
        totalUsers: 0,
        admin: 0,
        superAdmin: 0,
        pimpinan: 0,
        user: 0,
      };
      prev.totalUsers += 1;
      if (u.status === "admin") prev.admin += 1;
      else if (u.status === "super admin") prev.superAdmin += 1;
      else if (u.status === "pimpinan") prev.pimpinan += 1;
      else prev.user += 1;
      map.set(key, prev);
    });
    setDinasList(
      Array.from(map.values()).sort((a, b) =>
        a.nama_dinas.localeCompare(b.nama_dinas)
      )
    );
  }, [users]);

  // Filter dinas list untuk modal berdasarkan search
  useEffect(() => {
    let filtered = dinasList;

    // Filter berdasarkan search term
    if (dinasModalSearch) {
      filtered = filtered.filter((dinas) =>
        dinas.nama_dinas.toLowerCase().includes(dinasModalSearch.toLowerCase())
      );
    }

    setFilteredDinasList(filtered);
  }, [dinasList, dinasModalSearch]);

  const fetchUsers = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API_ESA_OFFICE}users/alldinas`);
      setUsers(response.data);
      setFilteredUsers(response.data);
    } catch (error) {
      console.error("Error fetching users:", error);
      swal({
        title: "Error!",
        text: "Gagal mengambil data users",
        icon: "error",
        button: "OK",
      });
    } finally {
      setLoading(false);
    }
  };

  // Fungsi untuk menghitung statistik dashboard
  const getDashboardStats = () => {
    const totalUsers = users.length;
    const adminUsers = users.filter((user) => user.status === "admin").length;
    const regularUsers = users.filter((user) => user.status === "user").length;

    // Hitung dinas unik
    const uniqueDinas = [...new Set(users.map((user) => user.dinas_id))].length;

    // Hitung bidang unik
    const uniqueBidang = [...new Set(users.map((user) => user.nama_bidang))]
      .length;

    return {
      totalUsers,
      adminUsers,
      regularUsers,
      uniqueDinas,
      uniqueBidang,
    };
  };

  const fetchStruktur = async (dinasId) => {
    if (!dinasId) return;

    setLoadingStruktur(true);
    try {
      const res = await axios.get(`${API_ESA_OFFICE}dinas/${dinasId}/struktur`);
      setDinasStruktur(res.data && res.data[0] ? res.data[0] : null);

      // Ambil opsi jabatan dari dinasStruktur jika ada
      const jabatanOptions =
        res.data[0] && Array.isArray(res.data[0].struktur)
          ? res.data[0].struktur.map((j) => ({
              value: j.nama_jabatan,
              label: j.nama_jabatan,
            }))
          : [];
      setJabatanOptions(jabatanOptions);
      // Ambil opsi bidang dari dinasStruktur jika ada
      const bidangOptions =
        res.data[0] && Array.isArray(res.data[0].bidang)
          ? res.data[0].bidang.map((b) => ({
              value: b.bidang_id,
              label: b.bidang,
            }))
          : [];
      setBidangOptions(bidangOptions);
    } catch (err) {
      setDinasStruktur(null);
    }
    setLoadingStruktur(false);
  };

  const handleOpenDialog = async (user) => {
    if (!user) return;

    setLoadingDialog(true);
    setSelectedUser(user);

    // Set selectedDinas berdasarkan dinas_id user
    const userDinas = listDinas.find((d) => d.dinas_id === user.dinas_id);
    if (userDinas) {
      setSelectedDinas(userDinas);
      // Fetch struktur dinas terlebih dahulu sebelum membuka dialog
      await fetchStruktur(userDinas.dinas_id);
    }

    setFormData({
      nama: user.nama || "",
      email: user.email || "",
      nama_jabatan: user.nama_jabatan || "",
      pangkat: user.pangkat || "",
      facebook: user.facebook || "",
      instagram: user.instagram || "",
      profil: user.profil || null,
      instansi: user.nama_dinas || "",
      jabatan: user.nama_jabatan || "",
      bidang: user.nama_bidang || "",
      status: user.status || "",
      unit: user.jenis_unit || "",
      bio: user.bio || "",
      noHP: user.noHP || "",
      status_EO: user.status_EO || "Aktif",
      // Field internal untuk keperluan backend (tidak ditampilkan)
      dinas_id: user.dinas_id || "",
      bidang_id: user.bidang_id || "",
      level_jabatan: user.level_jabatan || "",
    });

    setLoadingDialog(false);
    setOpenDialog(true);
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData({ ...formData, profil: file });
    }
  };

  const handleEdit = async () => {
    if (!selectedUser) return;

    try {
      // Susun payload JSON tanpa mengirim gambar (profil)
      const {
        nama,
        email,
        nama_jabatan,
        jabatan,
        level_jabatan,
        dinas_id,
        bidang_id,
        bidang,
        pangkat,
        status,
        facebook,
        instagram,
        unit,
        noHP,
        status_EO,
      } = formData;

      // Backend PUT membutuhkan: nama, email, nama_jabatan, level_jabatan, dinas_id, bidang_id, pangkat, status, facebook, instagram, noHP, status_EO
      const payload = {
        nama,
        email,
        nama_jabatan: nama_jabatan || jabatan || "",
        level_jabatan: level_jabatan || "",
        dinas_id: dinas_id || selectedDinas?.dinas_id || null,
        bidang_id: bidang_id || null,
        pangkat: pangkat || null,
        status: status || "user",
        facebook: facebook || null,
        instagram: instagram || null,
        noHP: noHP || null,
        status_EO: status_EO || "Aktif",
      };

      await axios.put(
        `${API_ESA_OFFICE}users/${selectedUser.user_id}`,
        payload
      );
      swal({
        title: "Berhasil!",
        text: "Data user berhasil diperbarui",
        icon: "success",
        button: "OK",
      });
      setOpenDialog(false);
      fetchUsers();
    } catch (error) {
      swal({
        title: "Error!",
        text:
          error.response?.data?.message ||
          "Terjadi kesalahan saat memperbarui data",
        icon: "error",
        button: "OK",
      });
    }
  };

  const handleDelete = (userId) => {
    swal({
      title: "Apakah Anda yakin?",
      text: "Data user akan dihapus secara permanen!",
      icon: "warning",
      buttons: ["Batal", "Ya, Hapus!"],
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          await axios.delete(`${API_ESA_OFFICE}users/${userId}`);
          swal({
            title: "Berhasil!",
            text: "User berhasil dihapus",
            icon: "success",
            button: "OK",
          });
          fetchUsers();
        } catch (error) {
          swal({
            title: "Error!",
            text:
              error.response?.data?.message ||
              "Terjadi kesalahan saat menghapus user",
            icon: "error",
            button: "OK",
          });
        }
      }
    });
  };

  // Fungsi export Excel untuk modal dinas
  const handleExportDinasExcel = () => {
    if (!filteredDinasList.length) {
      swal({
        title: "Info",
        text: "Tidak ada data untuk di-export",
        icon: "info",
        button: "OK",
      });
      return;
    }

    // Buat HTML table untuk Excel
    const tableHeaders = [
      "No",
      "Nama Dinas",
      "Total Users",
      "Admin",
      "Super Admin",
      "Pimpinan",
      "User",
    ];

    let tableRows = "";
    filteredDinasList.forEach((row, index) => {
      tableRows += `
        <tr>
          <td>${index + 1}</td>
          <td>${row.nama_dinas || ""}</td>
          <td>${row.totalUsers || 0}</td>
          <td>${row.admin || 0}</td>
          <td>${row.superAdmin || 0}</td>
          <td>${row.pimpinan || 0}</td>
          <td>${row.user || 0}</td>
        </tr>
      `;
    });

    const htmlContent = `
      <html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">
        <head>
          <meta charset="UTF-8">
          <title>Daftar Dinas dan Statistik User</title>
          <style>
            table { border-collapse: collapse; width: 100%; }
            th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
            th { background-color: #f2f2f2; font-weight: bold; }
          </style>
        </head>
        <body>
          <h2>Daftar Dinas dan Statistik User ESA Office</h2>
          <table>
            <thead>
              <tr>
                ${tableHeaders.map((header) => `<th>${header}</th>`).join("")}
              </tr>
            </thead>
            <tbody>
              ${tableRows}
            </tbody>
          </table>
        </body>
      </html>
    `;

    const blob = new Blob([htmlContent], {
      type: "application/vnd.ms-excel;charset=utf-8",
    });
    saveAs(
      blob,
      `daftar-dinas-statistik-${new Date().toISOString().split("T")[0]}.xls`
    );
  };

  const baseColumns = [
    {
      Header: "No",
      accessor: "no",
      width: "5%",
      Cell: ({ row }) => row.index + 1,
    },
    {
      Header: "Profil",
      accessor: "profil",
      width: "8%",
      Cell: ({ row }) => (
        <MDBox display="flex" alignItems="center">
          {row.original.profil ? (
            <img
              src={`https://smartdh.rotendaokab.go.id/uploads/${row.original.uid_RSS}.jpg`}
              alt={row.original.nama}
              style={{
                width: 40,
                height: 40,
                borderRadius: "50%",
              }}
            />
          ) : (
            <Icon sx={{ fontSize: 40, color: "text.secondary" }}>person</Icon>
          )}
        </MDBox>
      ),
    },
    { Header: "Nama", accessor: "nama", width: "15%" },
    { Header: "Email", accessor: "email", width: "18%" },

    {
      Header: "Nama Dinas",
      accessor: "nama_dinas",
      width: 200,
      minWidth: 200,
      maxWidth: 200,
      Cell: ({ value }) => (
        <MDTypography
          variant="caption"
          color="text"
          fontWeight="medium"
          sx={{
            wordWrap: "break-word",
            whiteSpace: "normal",
            lineHeight: 1.4,
            width: "200px",
            maxWidth: "200px",
            minWidth: "200px",
            display: "block",
          }}
        >
          {value}
        </MDTypography>
      ),
    },
    { Header: "Jabatan", accessor: "nama_jabatan", width: "12%" },
    {
      Header: "Nama Dinas",
      accessor: "nama_bidang",
      width: 200,
      minWidth: 200,
      maxWidth: 200,
      Cell: ({ value }) => (
        <MDTypography
          variant="caption"
          color="text"
          fontWeight="medium"
          sx={{
            wordWrap: "break-word",
            whiteSpace: "normal",
            lineHeight: 1.4,
            width: "200px",
            maxWidth: "200px",
            minWidth: "200px",
            display: "block",
          }}
        >
          {value}
        </MDTypography>
      ),
    },
    { Header: "Pangkat", accessor: "pangkat", width: "8%" },
    { Header: "No HP", accessor: "noHP", width: "10%" },
    {
      Header: "Status",
      accessor: "status",
      width: "8%",
      Cell: ({ value }) => (
        <MDTypography
          variant="caption"
          fontWeight="medium"
          color={
            value === "admin"
              ? "success"
              : value === "user"
              ? "info"
              : value === "super admin"
              ? "warning"
              : value === "pimpinan"
              ? "warning"
              : "text"
          }
        >
          {value && typeof value === "string" ? value.toUpperCase() : "-"}
        </MDTypography>
      ),
    },
    {
      Header: "Status EO",
      accessor: "status_EO",
      width: "10%",
      Cell: ({ value }) => (
        <MDTypography
          variant="caption"
          fontWeight="medium"
          color={
            value === "Aktif"
              ? "success"
              : value === "Non Aktif"
              ? "error"
              : value === "Pensiun"
              ? "warning"
              : value === "Meninggal"
              ? "error"
              : "text"
          }
        >
          {value || "Aktif"}
        </MDTypography>
      ),
    },
    {
      Header: "Facebook",
      accessor: "facebook",
      width: "12%",
      Cell: ({ value }) => (
        <MDBox display="flex" alignItems="center">
          {value && value !== "-" && value !== "Tidak ada" && (
            <MDBox
              component="a"
              href={`https://facebook.com/${value}`}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: "#1877F2",
                display: "flex",
                alignItems: "center",
                textDecoration: "none",
                "&:hover": {
                  textDecoration: "underline",
                },
              }}
            >
              <Icon sx={{ fontSize: 20, mr: 0.5 }}>facebook</Icon>
              <MDTypography variant="caption" fontWeight="medium">
                {value.length > 10 ? `${value.substring(0, 10)}...` : value}
              </MDTypography>
            </MDBox>
          )}
        </MDBox>
      ),
    },
    {
      Header: "Instagram",
      accessor: "instagram",
      width: "12%",
      Cell: ({ value }) => (
        <MDBox display="flex" alignItems="center">
          {value && value !== "-" && value !== "Tidak ada" && (
            <MDBox
              component="a"
              href={`https://instagram.com/${value.replace("@", "")}`}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: "#E1306C",
                display: "flex",
                alignItems: "center",
                textDecoration: "none",
                "&:hover": {
                  textDecoration: "underline",
                },
              }}
            >
              <Icon sx={{ fontSize: 20, mr: 0.5 }}>camera_alt</Icon>
              <MDTypography variant="caption" fontWeight="medium">
                {value.length > 10 ? `${value.substring(0, 10)}...` : value}
              </MDTypography>
            </MDBox>
          )}
        </MDBox>
      ),
    },
    // Kolom aksi akan ditambahkan secara kondisional
  ];

  const actionColumn = {
    Header: "Aksi",
    accessor: "aksi",
    width: "8%",
    Cell: ({ row }) => (
      <MDBox display="flex" alignItems="center" gap={1}>
        <MDButton
          variant="text"
          color="info"
          size="small"
          onClick={() => handleOpenDialog(row.original)}
          disabled={loadingDialog}
          sx={{ minWidth: "auto", p: 0.5 }}
        >
          {loadingDialog ? <CircularProgress size={16} /> : <Icon>edit</Icon>}
        </MDButton>
        <MDButton
          variant="text"
          color="error"
          size="small"
          onClick={() => handleDelete(row.original.user_id)}
          sx={{ minWidth: "auto", p: 0.5 }}
        >
          <Icon>delete</Icon>
        </MDButton>
      </MDBox>
    ),
  };

  const columns =
    userStatus === "admin" || userStatus === "super admin"
      ? [...baseColumns, actionColumn]
      : baseColumns;

  const stats = getDashboardStats();

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <MDBox mb={3}>
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item>
              <MDTypography variant="h4">
                Daftar Semua Users ESA Office
              </MDTypography>
              <MDTypography variant="body2" color="text">
                Rekapan pengguna sistem ESA Office
              </MDTypography>
            </Grid>
            <Grid item>
              <MDButton
                variant="gradient"
                color="info"
                onClick={() => navigate("/team/new-user")}
              >
                <Icon>add</Icon>&nbsp;Tambah User
              </MDButton>
            </Grid>
          </Grid>
        </MDBox>

        {/* Dashboard Rekapan */}
        <MDBox mb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6} md={2.4}>
              <Card
                onClick={() => setOpenDinasModal(true)}
                sx={{ cursor: "pointer" }}
              >
                <CardContent>
                  <MDBox display="flex" alignItems="center">
                    <MDBox
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      width="3rem"
                      height="3rem"
                      borderRadius="50%"
                      bgColor="info"
                      mr={2}
                    >
                      <Icon color="white">people</Icon>
                    </MDBox>
                    <MDBox>
                      <MDTypography variant="h6" fontWeight="bold">
                        {stats.totalUsers}
                      </MDTypography>
                      <MDTypography variant="caption" color="text">
                        Total Users
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} md={2.4}>
              <Card>
                <CardContent>
                  <MDBox display="flex" alignItems="center">
                    <MDBox
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      width="3rem"
                      height="3rem"
                      borderRadius="50%"
                      bgColor="success"
                      mr={2}
                    >
                      <Icon color="white">admin_panel_settings</Icon>
                    </MDBox>
                    <MDBox>
                      <MDTypography variant="h6" fontWeight="bold">
                        {stats.adminUsers}
                      </MDTypography>
                      <MDTypography variant="caption" color="text">
                        Admin
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} md={2.4}>
              <Card>
                <CardContent>
                  <MDBox display="flex" alignItems="center">
                    <MDBox
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      width="3rem"
                      height="3rem"
                      borderRadius="50%"
                      bgColor="primary"
                      mr={2}
                    >
                      <Icon color="white">person</Icon>
                    </MDBox>
                    <MDBox>
                      <MDTypography variant="h6" fontWeight="bold">
                        {stats.regularUsers}
                      </MDTypography>
                      <MDTypography variant="caption" color="text">
                        User Biasa
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} md={2.4}>
              <Card
                onClick={() => setOpenDinasModal(true)}
                sx={{ cursor: "pointer" }}
              >
                <CardContent>
                  <MDBox display="flex" alignItems="center">
                    <MDBox
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      width="3rem"
                      height="3rem"
                      borderRadius="50%"
                      bgColor="warning"
                      mr={2}
                    >
                      <Icon color="white">business</Icon>
                    </MDBox>
                    <MDBox>
                      <MDTypography variant="h6" fontWeight="bold">
                        {stats.uniqueDinas}
                      </MDTypography>
                      <MDTypography variant="caption" color="text">
                        Dinas
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} md={2.4}>
              <Card>
                <CardContent>
                  <MDBox display="flex" alignItems="center">
                    <MDBox
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      width="3rem"
                      height="3rem"
                      borderRadius="50%"
                      bgColor="error"
                      mr={2}
                    >
                      <Icon color="white">category</Icon>
                    </MDBox>
                    <MDBox>
                      <MDTypography variant="h6" fontWeight="bold">
                        {stats.uniqueBidang}
                      </MDTypography>
                      <MDTypography variant="caption" color="text">
                        Bidang
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </MDBox>

        {/* Pencarian */}
        <MDBox mb={3}>
          <MDInput
            fullWidth
            placeholder="Cari berdasarkan nama, email, atau nama dinas..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Icon>search</Icon>
                </InputAdornment>
              ),
            }}
          />
        </MDBox>

        {isMobile ? (
          <MDBox display="flex" flexDirection="column" gap={1}>
            {loading ? (
              <MDBox
                display="flex"
                justifyContent="center"
                alignItems="center"
                py={4}
              >
                <CircularProgress size={40} />
                <MDTypography variant="body2" color="text" ml={2}>
                  Memuat data pengguna...
                </MDTypography>
              </MDBox>
            ) : (
              <>
                {filteredUsers.slice(0, visibleCount).map((user, index) => (
                  <Card key={`${user.user_id || "user"}-${index}`}>
                    <CardContent>
                      <Grid container spacing={2} alignItems="center">
                        <Grid item xs={4}>
                          <MDBox
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                          >
                            {user.profil ? (
                              <img
                                src={`https://smartdh.rotendaokab.go.id/uploads/${user.uid_RSS}.jpg`}
                                alt={user.nama}
                                style={{
                                  width: 72,
                                  height: 72,
                                  borderRadius: "50%",
                                  objectFit: "cover",
                                  border: "2px solid #e0e0e0",
                                }}
                                onError={(e) => {
                                  e.currentTarget.style.display = "none";
                                  const sibling = e.currentTarget.nextSibling;
                                  if (sibling) sibling.style.display = "flex";
                                }}
                              />
                            ) : null}
                            <MDBox
                              display={user.profil ? "none" : "flex"}
                              alignItems="center"
                              justifyContent="center"
                              sx={{
                                width: 72,
                                height: 72,
                                borderRadius: "50%",
                                backgroundColor: "grey.200",
                                color: "grey.500",
                              }}
                            >
                              <Icon sx={{ fontSize: 36 }}>person</Icon>
                            </MDBox>
                          </MDBox>
                        </Grid>
                        <Grid item xs={8}>
                          <MDTypography variant="button" fontWeight="bold">
                            {user.nama}
                          </MDTypography>
                          <MDTypography
                            variant="caption"
                            color="text.secondary"
                            display="block"
                          >
                            {user.email || "-"}
                          </MDTypography>
                          <MDBox
                            mt={1}
                            display="flex"
                            flexWrap="wrap"
                            gap={0.5}
                          >
                            {user.nama_dinas ? (
                              <Chip
                                label={`Dinas: ${user.nama_dinas}`}
                                size="small"
                                color="primary"
                              />
                            ) : null}
                            {user.nama_jabatan ? (
                              <Chip
                                label={`Jabatan: ${user.nama_jabatan}`}
                                size="small"
                                color="info"
                              />
                            ) : null}
                            {user.nama_bidang ? (
                              <Chip
                                label={`Bidang: ${user.nama_bidang}`}
                                size="small"
                                color="secondary"
                              />
                            ) : null}
                            {user.pangkat ? (
                              <Chip
                                label={`Pangkat: ${getPangkatLabel(
                                  user.pangkat
                                )}`}
                                size="small"
                                color="warning"
                              />
                            ) : null}
                            {user.status ? (
                              <Chip
                                label={`Status: ${user.status}`}
                                size="small"
                                color={
                                  user.status === "admin"
                                    ? "success"
                                    : user.status === "user"
                                    ? "info"
                                    : user.status === "super admin" ||
                                      user.status === "pimpinan"
                                    ? "warning"
                                    : "default"
                                }
                              />
                            ) : null}
                            {user.noHP ? (
                              <Chip
                                label={`HP: ${user.noHP}`}
                                size="small"
                                color="info"
                              />
                            ) : null}
                            {user.status_EO ? (
                              <Chip
                                label={`Status EO: ${user.status_EO}`}
                                size="small"
                                color={
                                  user.status_EO === "Aktif"
                                    ? "success"
                                    : user.status_EO === "Non Aktif" ||
                                      user.status_EO === "Meninggal"
                                    ? "error"
                                    : user.status_EO === "Pensiun"
                                    ? "warning"
                                    : "default"
                                }
                              />
                            ) : null}
                          </MDBox>
                          {(userStatus === "admin" ||
                            userStatus === "super admin") && (
                            <MDBox mt={1} display="flex" gap={1}>
                              <MDButton
                                variant="outlined"
                                color="info"
                                size="small"
                                onClick={() => handleOpenDialog(user)}
                                sx={{ minWidth: "auto", px: 1 }}
                              >
                                <Icon sx={{ fontSize: 16 }}>edit</Icon>
                                &nbsp;Edit
                              </MDButton>
                              <MDButton
                                variant="outlined"
                                color="error"
                                size="small"
                                onClick={() => handleDelete(user.user_id)}
                                sx={{ minWidth: "auto", px: 1 }}
                              >
                                <Icon sx={{ fontSize: 16 }}>delete</Icon>
                                &nbsp;Hapus
                              </MDButton>
                            </MDBox>
                          )}
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                ))}
                {isLoadingMore && (
                  <MDBox py={2} textAlign="center">
                    <CircularProgress size={24} />
                  </MDBox>
                )}
              </>
            )}
          </MDBox>
        ) : (
          <>
            {loading ? (
              <MDBox
                display="flex"
                justifyContent="center"
                alignItems="center"
                py={4}
              >
                <CircularProgress size={40} />
                <MDTypography variant="body2" color="text" ml={2}>
                  Memuat data pengguna...
                </MDTypography>
              </MDBox>
            ) : (
              <DataTable
                table={{
                  columns,
                  rows: filteredUsers,
                }}
                entriesPerPage={false}
                showTotalEntries={false}
                isSorted={false}
                noEndBorder
              />
            )}
          </>
        )}

        {/* Modal Daftar Dinas */}
        <Dialog
          open={openDinasModal}
          onClose={() => setOpenDinasModal(false)}
          maxWidth="lg"
          fullWidth
        >
          <DialogTitle>
            <MDBox
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <MDTypography variant="h4" fontWeight="bold">
                Daftar Dinas dan Statistik User
              </MDTypography>
              <MDButton
                variant="gradient"
                color="success"
                onClick={handleExportDinasExcel}
                disabled={!filteredDinasList.length}
                size="small"
              >
                <Icon>description</Icon>
                &nbsp;Export Excel
              </MDButton>
            </MDBox>
          </DialogTitle>
          <DialogContent>
            {/* Search untuk Modal Dinas */}
            <MDBox mb={3}>
              <MDInput
                fullWidth
                placeholder="Cari nama dinas..."
                value={dinasModalSearch}
                onChange={(e) => setDinasModalSearch(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Icon>search</Icon>
                    </InputAdornment>
                  ),
                }}
              />
            </MDBox>
            <DataTable
              table={{
                columns: [
                  {
                    Header: "No",
                    accessor: "no",
                    width: "5%",
                    Cell: ({ row }) => row.index + 1,
                  },
                  {
                    Header: "Nama Dinas",
                    accessor: "nama_dinas",
                    width: 200,
                    minWidth: 200,
                    maxWidth: 200,
                    Cell: ({ value }) => (
                      <MDTypography
                        variant="caption"
                        color="text"
                        fontWeight="medium"
                        sx={{
                          wordWrap: "break-word",
                          whiteSpace: "normal",
                          lineHeight: 1.4,
                          width: "200px",
                          maxWidth: "200px",
                          minWidth: "200px",
                          display: "block",
                        }}
                      >
                        {value}
                      </MDTypography>
                    ),
                  },
                  {
                    Header: "Total Users",
                    accessor: "totalUsers",
                    width: "15%",
                    Cell: ({ value }) => (
                      <MDTypography
                        variant="caption"
                        fontWeight="bold"
                        color="info"
                      >
                        {value}
                      </MDTypography>
                    ),
                  },
                  {
                    Header: "Admin",
                    accessor: "admin",
                    width: "15%",
                    Cell: ({ value }) => (
                      <MDTypography
                        variant="caption"
                        fontWeight="medium"
                        color="success"
                      >
                        {value}
                      </MDTypography>
                    ),
                  },
                  {
                    Header: "Super Admin",
                    accessor: "superAdmin",
                    width: "15%",
                    Cell: ({ value }) => (
                      <MDTypography
                        variant="caption"
                        fontWeight="medium"
                        color="warning"
                      >
                        {value}
                      </MDTypography>
                    ),
                  },
                  {
                    Header: "Pimpinan",
                    accessor: "pimpinan",
                    width: "15%",
                    Cell: ({ value }) => (
                      <MDTypography
                        variant="caption"
                        fontWeight="medium"
                        color="warning"
                      >
                        {value}
                      </MDTypography>
                    ),
                  },
                  {
                    Header: "User",
                    accessor: "user",
                    width: "15%",
                    Cell: ({ value }) => (
                      <MDTypography
                        variant="caption"
                        fontWeight="medium"
                        color="text"
                      >
                        {value}
                      </MDTypography>
                    ),
                  },
                ],
                rows: filteredDinasList,
              }}
              entriesPerPage={false}
              showTotalEntries={false}
              isSorted={false}
              noEndBorder
            />
          </DialogContent>
          <DialogActions sx={{ p: 3 }}>
            <MDButton
              onClick={() => {
                setOpenDinasModal(false);
                // Reset search saat modal ditutup
                setDinasModalSearch("");
              }}
              variant="outlined"
              color="secondary"
            >
              Tutup
            </MDButton>
          </DialogActions>
        </Dialog>

        <Dialog
          open={openDialog}
          onClose={() => setOpenDialog(false)}
          maxWidth="lg"
          fullWidth
        >
          <DialogTitle>
            <MDTypography variant="h4" align="center" fontWeight="bold">
              Edit User - {selectedUser?.nama || ""}
            </MDTypography>
          </DialogTitle>
          <DialogContent>
            <MDBox
              display="flex"
              flexDirection="column"
              alignItems="center"
              mb={4}
            >
              <MDBox
                component="label"
                htmlFor="profil-upload"
                sx={{
                  position: "relative",
                  cursor: "pointer",
                  "&:hover .overlay": {
                    opacity: 1,
                  },
                }}
              >
                <MDBox
                  component="img"
                  src={
                    formData.profil instanceof File
                      ? URL.createObjectURL(formData.profil)
                      : selectedUser?.profil
                      ? `https://smartdh.rotendaokab.go.id/uploads/${selectedUser.uid_RSS}.jpg`
                      : "https://via.placeholder.com/150"
                  }
                  alt="Profile"
                  sx={{
                    width: 150,
                    height: 150,
                    borderRadius: "50%",
                    objectFit: "cover",
                    border: "4px solid #fff",
                    boxShadow: "0 0 10px rgba(0,0,0,0.1)",
                  }}
                />
                <MDBox
                  className="overlay"
                  sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    borderRadius: "50%",
                    backgroundColor: "rgba(0,0,0,0.5)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    opacity: 0,
                    transition: "opacity 0.3s",
                  }}
                >
                  <Icon sx={{ color: "white", fontSize: 40 }}>
                    photo_camera
                  </Icon>
                </MDBox>
              </MDBox>
              <input
                type="file"
                id="profil-upload"
                accept="image/*"
                onChange={handleImageChange}
                style={{ display: "none" }}
              />
              <MDTypography variant="button" color="text" mt={1}>
                Klik untuk mengubah foto
              </MDTypography>
            </MDBox>

            {/* Akun RSS Section */}
            <MDBox mb={3}>
              <MDTypography variant="h6" fontWeight="bold" color="primary">
                Akun Rote Smart Service
              </MDTypography>
              <MDTypography variant="caption" color="text">
                Informasi akun RSS user
              </MDTypography>
            </MDBox>

            <Grid container spacing={3}>
              <Grid item xs={12}>
                <MDInput
                  type="email"
                  label="Email Address"
                  fullWidth
                  value={formData.email}
                />
              </Grid>
            </Grid>

            {/* Info User Section */}
            <MDBox mb={3} mt={4}>
              <MDTypography variant="h6" fontWeight="bold" color="primary">
                Informasi User
              </MDTypography>
              <MDTypography variant="caption" color="text">
                Data pribadi dan jabatan user
              </MDTypography>
            </MDBox>

            <Grid container spacing={3}>
              <Grid item xs={12} md={12}>
                <MDInput
                  type="text"
                  label="Nama Lengkap"
                  fullWidth
                  value={formData.nama}
                  onChange={(e) =>
                    setFormData({ ...formData, nama: e.target.value })
                  }
                  placeholder="Nama lengkap beserta gelar"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <MDBox mb={1} ml={0.5}>
                  <MDTypography
                    component="label"
                    variant="caption"
                    fontWeight="regular"
                    color="text"
                  >
                    Instansi
                  </MDTypography>
                </MDBox>
                <Autocomplete
                  value={selectedDinas}
                  onChange={(event, newValue) => {
                    setSelectedDinas(newValue);
                  }}
                  options={listDinas}
                  getOptionLabel={(option) => option.nama_dinas || ""}
                  isOptionEqualToValue={(option, value) =>
                    option.dinas_id === value?.dinas_id
                  }
                  loading={loadingDinas}
                  disabled={loadingDinas}
                  renderInput={(params) => (
                    <MDInput
                      {...params}
                      placeholder="Pilih Dinas"
                      variant="outlined"
                      fullWidth
                    />
                  )}
                  renderOption={(props, option) => (
                    <li {...props} key={option.dinas_id}>
                      {option.nama_dinas}
                    </li>
                  )}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <MDBox mb={1} ml={0.5}>
                  <MDTypography
                    component="label"
                    variant="caption"
                    fontWeight="regular"
                    color="text"
                  >
                    Jabatan
                  </MDTypography>
                </MDBox>
                <Autocomplete
                  value={
                    formData.jabatan
                      ? {
                          value: formData.jabatan,
                          label: formData.jabatan,
                        }
                      : null
                  }
                  onChange={(event, newValue) => {
                    const selectedJabatan = newValue?.value || "";
                    let level = "";
                    if (
                      dinasStruktur &&
                      Array.isArray(dinasStruktur.struktur)
                    ) {
                      const found = dinasStruktur.struktur.find(
                        (j) => j.nama_jabatan === selectedJabatan
                      );
                      if (found) level = found.level_jabatan;
                    }
                    setFormData({
                      ...formData,
                      nama_jabatan: selectedJabatan,
                      jabatan: selectedJabatan,
                      level_jabatan: level,
                    });
                  }}
                  options={jabatanOptions}
                  getOptionLabel={(option) => option.label || ""}
                  isOptionEqualToValue={(option, value) =>
                    option.value === value?.value
                  }
                  loading={loadingStruktur}
                  disabled={loadingStruktur}
                  renderInput={(params) => (
                    <MDInput
                      {...params}
                      placeholder="Pilih Jabatan"
                      variant="outlined"
                      fullWidth
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <MDBox mb={1} ml={0.5}>
                  <MDTypography
                    component="label"
                    variant="caption"
                    fontWeight="regular"
                    color="text"
                  >
                    Bidang
                  </MDTypography>
                </MDBox>
                <Autocomplete
                  value={
                    formData.bidang
                      ? {
                          value: formData.bidang_id,
                          label: formData.bidang,
                        }
                      : null
                  }
                  onChange={(event, newValue) => {
                    const selectedBidangId = newValue?.value || "";
                    const selectedBidang =
                      dinasStruktur && Array.isArray(dinasStruktur.bidang)
                        ? dinasStruktur.bidang.find(
                            (b) => b.bidang_id == selectedBidangId
                          )
                        : null;
                    setFormData({
                      ...formData,
                      bidang_id: selectedBidangId,
                      bidang: selectedBidang ? selectedBidang.bidang : "",
                    });
                  }}
                  options={bidangOptions}
                  getOptionLabel={(option) => option.label || ""}
                  isOptionEqualToValue={(option, value) =>
                    option.value === value?.value
                  }
                  loading={loadingStruktur}
                  disabled={loadingStruktur}
                  renderInput={(params) => (
                    <MDInput
                      {...params}
                      placeholder="Pilih Bidang"
                      variant="outlined"
                      fullWidth
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <MDBox mb={1} ml={0.5}>
                  <MDTypography
                    component="label"
                    variant="caption"
                    fontWeight="regular"
                    color="text"
                  >
                    Pangkat
                  </MDTypography>
                </MDBox>
                <Autocomplete
                  value={
                    formData.pangkat
                      ? {
                          value: formData.pangkat,
                          label: getPangkatLabel(formData.pangkat),
                        }
                      : null
                  }
                  onChange={(event, newValue) => {
                    setFormData({
                      ...formData,
                      pangkat: newValue?.value || "",
                    });
                  }}
                  options={[
                    { value: "IA", label: "Juru Muda (I/a)" },
                    { value: "IB", label: "Juru Muda Tingkat I (I/b)" },
                    { value: "IC", label: "Juru (I/c)" },
                    { value: "ID", label: "Juru Tingkat I (I/d)" },
                    { value: "IIA", label: "Pengatur Muda (II/a)" },
                    { value: "IIB", label: "Pengatur Muda Tingkat I (II/b)" },
                    { value: "IIC", label: "Pengatur (II/c)" },
                    { value: "IID", label: "Pengatur Tingkat I (II/d)" },
                    { value: "IIIA", label: "Penata Muda (III/a)" },
                    { value: "IIIB", label: "Penata Muda Tingkat I (III/b)" },
                    { value: "IIIC", label: "Penata (III/c)" },
                    { value: "IIID", label: "Penata Tingkat I (III/d)" },
                    { value: "IVA", label: "Pembina (IV/a)" },
                    { value: "IVB", label: "Pembina Tingkat I (IV/b)" },
                    { value: "IVC", label: "Pembina Utama Muda (IV/c)" },
                    { value: "IVD", label: "Pembina Utama Madya (IV/d)" },
                  ]}
                  getOptionLabel={(option) => option.label || ""}
                  isOptionEqualToValue={(option, value) =>
                    option.value === value?.value
                  }
                  renderInput={(params) => (
                    <MDInput
                      {...params}
                      placeholder="Pilih Pangkat/Golongan"
                      variant="outlined"
                      fullWidth
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <MDBox mb={1} ml={0.5}>
                  <MDTypography
                    component="label"
                    variant="caption"
                    fontWeight="regular"
                    color="text"
                  >
                    Status
                  </MDTypography>
                </MDBox>
                <Autocomplete
                  value={
                    formData.status
                      ? {
                          value: formData.status,
                          label: formData.status === "user" ? "User" : "Admin",
                        }
                      : null
                  }
                  onChange={(event, newValue) => {
                    setFormData({ ...formData, status: newValue?.value || "" });
                  }}
                  options={[
                    { value: "user", label: "User" },
                    { value: "admin", label: "Admin" },
                  ]}
                  getOptionLabel={(option) => option.label || ""}
                  isOptionEqualToValue={(option, value) =>
                    option.value === value?.value
                  }
                  renderInput={(params) => (
                    <MDInput
                      {...params}
                      placeholder="Pilih Status"
                      variant="outlined"
                      fullWidth
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <MDInput
                  type="select"
                  label="Unit"
                  fullWidth
                  value={formData.unit}
                  onChange={(e) =>
                    setFormData({ ...formData, unit: e.target.value })
                  }
                  options={[
                    { value: "", label: "Pilih Unit" },
                    { value: "Sekretariat", label: "Sekretariat" },
                    { value: "Sub Bagian", label: "Sub Bagian" },
                    { value: "Bidang", label: "Bidang" },
                    { value: "Seksi", label: "Seksi" },
                    { value: "UPT", label: "UPT" },
                    { value: "Lainnya", label: "Lainnya" },
                  ]}
                />
              </Grid>
            </Grid>

            {/* Socials Section */}
            <MDBox mb={3} mt={4}>
              <MDTypography variant="h6" fontWeight="bold" color="primary">
                Social Media
              </MDTypography>
              <MDTypography variant="caption" color="text">
                Akun media sosial user
              </MDTypography>
            </MDBox>

            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <MDInput
                  type="text"
                  label="No HP"
                  fullWidth
                  value={formData.noHP}
                  onChange={(e) =>
                    setFormData({ ...formData, noHP: e.target.value })
                  }
                  placeholder="Nomor HP/WhatsApp"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Icon>phone</Icon>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <MDBox mb={1} ml={0.5}>
                  <MDTypography
                    component="label"
                    variant="caption"
                    fontWeight="regular"
                    color="text"
                  >
                    Status EO
                  </MDTypography>
                </MDBox>
                <Autocomplete
                  value={
                    formData.status_EO
                      ? {
                          value: formData.status_EO,
                          label: formData.status_EO,
                        }
                      : { value: "Aktif", label: "Aktif" }
                  }
                  onChange={(event, newValue) => {
                    setFormData({
                      ...formData,
                      status_EO: newValue?.value || "Aktif",
                    });
                  }}
                  options={[
                    { value: "Aktif", label: "Aktif" },
                    { value: "Non Aktif", label: "Non Aktif" },
                    {
                      value: "Pindah Ke Luar Kabupaten",
                      label: "Pindah Ke Luar Kabupaten",
                    },
                    { value: "Meninggal", label: "Meninggal" },
                    { value: "Pensiun", label: "Pensiun" },
                    { value: "Dipecat", label: "Dipecat" },
                  ]}
                  getOptionLabel={(option) => option.label || ""}
                  isOptionEqualToValue={(option, value) =>
                    option.value === value?.value
                  }
                  renderInput={(params) => (
                    <MDInput
                      {...params}
                      placeholder="Pilih Status EO"
                      variant="outlined"
                      fullWidth
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <MDInput
                  type="text"
                  label="Facebook Account"
                  fullWidth
                  value={formData.facebook}
                  onChange={(e) =>
                    setFormData({ ...formData, facebook: e.target.value })
                  }
                  placeholder="Username Facebook"
                  InputProps={{
                    startAdornment: (
                      <Icon sx={{ color: "#1877F2", mr: 1 }}>facebook</Icon>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <MDInput
                  type="text"
                  label="Instagram Account"
                  fullWidth
                  value={formData.instagram}
                  onChange={(e) =>
                    setFormData({ ...formData, instagram: e.target.value })
                  }
                  placeholder="Username Instagram"
                  InputProps={{
                    startAdornment: (
                      <Icon sx={{ color: "#E1306C", mr: 1 }}>camera_alt</Icon>
                    ),
                  }}
                />
              </Grid>
            </Grid>

            {/* Profile Section */}
            <MDBox mb={3} mt={4}>
              <MDTypography variant="h6" fontWeight="bold" color="primary">
                Profile
              </MDTypography>
              <MDTypography variant="caption" color="text">
                Informasi tambahan dan bio user
              </MDTypography>
            </MDBox>

            <Grid container spacing={3}>
              <Grid item xs={12}>
                <MDInput
                  type="text"
                  label="Bio"
                  fullWidth
                  multiline
                  rows={5}
                  value={formData.bio}
                  onChange={(e) =>
                    setFormData({ ...formData, bio: e.target.value })
                  }
                  placeholder="Tuliskan bio atau deskripsi singkat tentang user"
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions sx={{ p: 3 }}>
            <MDButton
              onClick={() => setOpenDialog(false)}
              variant="outlined"
              color="secondary"
            >
              Batal
            </MDButton>
            <MDButton onClick={handleEdit} variant="gradient" color="info">
              Simpan Perubahan
            </MDButton>
          </DialogActions>
        </Dialog>
      </MDBox>
    </DashboardLayout>
  );
}

export default DaftarUsers;
